import React from "react";
import { IonBadge, IonIcon, IonText } from "@ionic/react";
import { statusDetail } from "../../utils/statusDetail";
import { Document } from "../../@types/document";

interface ComponentProps {
  document: Document;
}

export const DocumentStatusTag: React.FC<ComponentProps> = ({ document }) => {
  const { status } = document;
  const statusIcon = statusDetail.find(
    ({ code, module }) => status?.code === code && status?.module === module
  );

  return (
    <IonBadge color={statusIcon?.color}>
      <IonIcon icon={statusIcon?.icon}></IonIcon>
      <IonText class="ion-margin-start ion-hide-sm-down">{status?.name}</IonText>
    </IonBadge>
  );
};
